module.exports = __webpack_public_path__ + "img/user-banner-bg.fff158d9.jpg";